
export const GET_ALL_PREFIX_URLS = `
    query {
        getAllPrefixUrls {
            prefixUrl
            id
        }
    }`;

export const GET_ALL_CLIENTS_ADMIN = `query {
  getAllClientsAdmin {
    id
    slug
    auth {
      username
    }
    business {
      name
      slogan
    }
    whatsintegration {
      status
      connectedNumber
    }
    staff {
      status
      name
    }
    subscription {
      isActive
      planName
      seats
      addons {
        inventory
        loyaltyCards
        aiAssistant
      }
      addonsNextCycle {
        inventory
        loyaltyCards
        aiAssistant
      }
      addonsNextCycleAt
      aiMonthlyCap
      startsAt
      expiresAt
      nextPaymentDate
    }
  }
}`;

export const GET_STAFF_BY_CLIENT_ID = `
  query ($clientId: String!) {
    getStaffByClientId(clientId: $clientId) {
      id
      name
    }
  }
`;

export const getSlug = `query ($slug: String!) {
  getClient(slug: $slug) {
    slug
  }
}`;

export const GET_CLIENT_BY_SLUG = `query ($slug: String!) {
    getClientSlug(slug: $slug) {
      id
      slug
      configComplete
      staff {
        id
        name
        status
        avatarSeed
        schedule {
          maxAdvancedDays
          workingHours {
            day
            start
            end
          }
          disabledDays
          disabledHours {
            day
            start
            end
          }
        }
        useBusinessSchedule
      }
      business {
        name
        slogan
        phones
        address
        email
        mapsUrl
        links {
          whatsapp
          facebook
          instagram
          twitter
          tiktok
        }
        services {
          name
          description
          durationMinutes
          price
          images
          requiresAdvance
          advanceAmount
        }
      }
      personalization {
        logoType
        selectedIcon
        primaryColor
        primaryDark
        confirmWebAppointment
        format24Hours
        logoImage
        avatarStyle
        staffLabel
        announcement {
          enabled
          title
          message
          updatedAt
        }
      }
    }
}`;

export const GET_CLIENT_BY_ID = `query ($id: String!) {
    getClientById(id: $id) {
      id
      configComplete
    auth {
        username
      }
    business {
        name
        slogan
        phones
        address
        email
        mapsUrl
        blockBase
      links {
          whatsapp
          facebook
          instagram
          twitter
          tiktok
        }
      services {
          name
          description
          durationMinutes
          price
          images
          requiresAdvance
          advanceAmount
          colorId
        }
      }
    botConfig {
        keywords
        ignoredNumbers
        confirmationMessage
        welcomeMessage
        reminders {
          enabled
          minutesBefore
          minutesReminderMessage
          minDaysForReminder
          daysReminderMessage
        }
        responses {
          trigger
          type
          response
        }
        blacklist {
          numbers {
            number
            country
            reason
            addedAt
          }
        }
        whatsappBookingEnabled  
      }
    schedule {
      maxAdvancedDays
      workingHours {
        day
        start
        end
      }
      disabledDays
      disabledHours {
        day
        start
        end
      }
    }
    whatsintegration {
        status
      }
    staff {
        id
        status
        name
        avatarSeed
        useBusinessSchedule
        schedule {
          maxAdvancedDays
          workingHours {
            day
            start
            end
          }
          disabledDays
          disabledHours {
            day
            start
            end
          }
        }
      }
    personalization {
        logoType
        selectedIcon
        primaryColor
        primaryDark
        confirmWebAppointment
        format24Hours
        logoImage
        avatarStyle
        staffLabel
        announcement {
          enabled
          title
          message
          updatedAt
        }
      }
    subscription {
        isActive
        planName
        seats
        addons {
          inventory
          loyaltyCards
          aiAssistant
        }
        addonsNextCycle {
          inventory
          loyaltyCards
          aiAssistant
        }
        addonsNextCycleAt
        aiMonthlyCap
        startsAt
        expiresAt
        nextPaymentDate
      }
      createdAt
      updatedAt
      slug
      paymentSettings {
        advanceInstructions
      }
      assistant {
        enabled
        name
        tone
        extraInfo
      }
      loyalty {
        enabled
        tiers {
          visits
          title
          description
        }
        repeatCycle
        sendOnFirstAppointment
        version
      }
    }
}`;


